import React, { useState } from 'react'
import PropTypes from 'prop-types'


// The editor's right-hand pane: the item as learners will see it on consultdex.com, drawn
// from the form's current values so it follows every keystroke. Nothing here saves.
// SPEC.md, "Editors".
export const PreviewPage = ({
  kicker = '',
  title,
  byline = '',
  facts = [],
  media = null,
  html = '',
  emptyText = 'Start typing and your page appears here.'
}) => {
  const visibleFacts = facts.filter(fact => fact.value !== '' && fact.value !== null && fact.value !== undefined)
  const isEmpty = !title && !html

  return (
    <article className="preview-page" aria-label="Preview of the public page">
      {kicker && <p className="preview-kicker">{kicker}</p>}
      <h2 className="preview-title">{title || 'Untitled'}</h2>
      {byline && <p className="preview-byline">{byline}</p>}

      {!!visibleFacts.length && (
        <dl className="preview-facts">
          {visibleFacts.map(fact => (
            <div key={fact.label}>
              <dt>{fact.label}</dt>
              <dd>{fact.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {media?.previewUrl && (
        <figure className={`preview-media${media.type === 'YouTube' ? ' is-video' : ''}`}>
          <img src={media.previewUrl} alt="" />
        </figure>
      )}

      {html
        ? <div className="preview-body" dangerouslySetInnerHTML={{ __html: html }} />
        : isEmpty && <p className="preview-empty">{emptyText}</p>}
    </article>
  )
}


PreviewPage.propTypes = {
  kicker: PropTypes.string,
  title: PropTypes.string,
  byline: PropTypes.string,
  facts: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.node })),
  media: PropTypes.object,
  html: PropTypes.string,
  emptyText: PropTypes.string
}


// Form on the left, preview on the right from 1200px; below that the preview is a toggle.
export const EditorWithPreview = ({ preview, children }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)

  return (
    <div className={`editor-with-preview${isPreviewOpen ? ' is-preview-open' : ''}`}>
      <button
        type="button"
        className="btn btn-secondary editor-preview-toggle"
        aria-expanded={isPreviewOpen}
        onClick={() => setIsPreviewOpen(!isPreviewOpen)}
      >
        {isPreviewOpen ? 'Back to editing' : 'Preview'}
      </button>

      <div className="editor-form">
        {children}
      </div>

      <aside className="editor-preview" aria-label="Live preview">
        <p className="editor-preview-label">Live preview</p>
        <div className="editor-preview-frame">
          {preview}
        </div>
      </aside>
    </div>
  )
}


EditorWithPreview.propTypes = {
  preview: PropTypes.node.isRequired
}
